import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { useState } from "react";
import SplashScreen from "./components/feature/SplashScreen";
import { SplashProvider, useSplashComplete } from "./components/feature/SplashContext";
import useScrollToTop from "./hooks/useScrollToTop";

function ScrollToTopWrapper() {
  useScrollToTop();
  return null;
}

function AppInner() {
  const [showSplash, setShowSplash] = useState(true);
  const { setSplashComplete } = useSplashComplete();

  return (
    <>
      <ScrollToTopWrapper />
      {showSplash && (
        <SplashScreen
          onComplete={() => {
            setShowSplash(false);
            setSplashComplete(true);
          }}
        />
      )}
      <AppRoutes />
    </>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <SplashProvider>
          <AppInner />
        </SplashProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;